import AppRoutes from './assets/layouts/navigation/AppRoutes'
import { ComponentNavigation } from './assets/layouts/navigation/ComponentNavigation'
import React, { useEffect } from 'react'
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { AdminPath } from './utils/AppSetting';

const App = () => {
  if (window.location.hostname.endsWith('.amplifyapp.com')) {
    let host = AdminPath;
    window.location.replace(
      host +
      window.location.pathname +
      window.location.search
    );
  }
  return (
    <div>
      <AppRoutes componentRoutes={ComponentNavigation} />
    </div>
  )
}

export default App
